import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI, Routing } from "../../api";
import '../dialog/dialog';
import { DialogViewModel } from '../dialog/dialog';

class CalculatorViewModel {
    RVGList = new Array();

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async pickGeneric (title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    async pickCase() {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akte", ["Registernummer", "Rubrum", "Wegen"], ["Registernummer", "Rubrum", "Wegen"], cases);
        this.modalHandleSelection((selectedObject) => $("#pnr").val(selectedObject()["Registernummer"]));
        $('#modal').modal('show');
    };

    SummeRVGUSt() {
        $('#rvgQuestionModal').modal('hide');
        this.SummeRVGGeb();

        var keys = Object.keys(this.RVGList);
        var len = keys.length

        var berechnung: any = 0;
        var ustberechnung: any = 0;
        for (var i = 1; i < len + 1; i++) {
            if (this.RVGList[i].Art === '=') continue;
            var gebuehr = parseFloat(this.RVGList[i].Gebuehr.replace(',', '.'));
            berechnung += gebuehr;
        }

        berechnung = Math.round(berechnung * 100) / 100;
        berechnung = berechnung.toFixed(2);

        ustberechnung = (berechnung / 100) * 19;

        berechnung = berechnung.toString();
        berechnung = berechnung.replace('.', ',');
        ustberechnung = ustberechnung.toFixed(2);
        ustberechnung = ustberechnung.toString();
        ustberechnung = ustberechnung.replace('.', ',');



        if (berechnung !== "0,00") {
            this.RVGList[len + 1] = { Art: 'U19', Nummer: "7008", Bezeichnung: "19,00 % Umsatzsteuer aus " + berechnung + " EUR", GebuehrenSatz: "", Streitwert: "", Gebuehr: ustberechnung }

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);

            var cell = new Array();
            for (var i = 0; i < 7; i++) {
                cell[i] = newRow.insertCell(i);
                cell[i].setAttribute("class", "text-left");
            }

            var text = new Array();
            text[0] = document.createTextNode(this.RVGList[len + 1].Art);
            text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
            text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
            text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
            text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
            text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
            text[6] = document.createTextNode("");


            for (var i = 0; i < 7; i++) {
                cell[i].appendChild(text[i]);
            }
        }
    }


    SummeRVGGeb() {
        $('#rvgQuestionModal').modal('hide');
        var keys = Object.keys(this.RVGList);
        var len = keys.length

        var berechnung: any = 0;
        for (var i = 1; i < len + 1; i++) {
            if (this.RVGList[i].Art === '=') continue;
            var gebuehr = parseFloat(this.RVGList[i].Gebuehr.replace(',', '.'));
            berechnung += gebuehr;
        }

        berechnung = Math.round(berechnung * 100) / 100;
        berechnung = berechnung.toFixed(2);
        berechnung = berechnung.toString();
        berechnung = berechnung.replace('.', ',');

        if (berechnung !== "0,00") {
            if (this.RVGList[len].Art !== '=') {
                this.RVGList[len + 1] = { Art: '=', Nummer: "", Bezeichnung: "Summe", GebuehrenSatz: "", Streitwert: "", Gebuehr: berechnung }

                var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
                var newRow = tableRef.insertRow(tableRef.rows.length);

                var cell = new Array();
                for (var i = 0; i < 7; i++) {
                    cell[i] = newRow.insertCell(i);
                    cell[i].setAttribute("class", "text-left");
                }

                var text = new Array();
                text[0] = document.createTextNode(this.RVGList[len + 1].Art);
                text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
                text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
                text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
                text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
                text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
                text[6] = document.createTextNode("");


                for (var i = 0; i < 7; i++) {
                    cell[i].appendChild(text[i]);
                }
            }
        }

    }

    SummeRVGQuestion() {
        //var modal = document.getElementById("rvgQuestionModal");
        $('#rvgQuestionModal').modal('show');
    }

    OpenRVGGeb() {
        if ($("#pnr").val() !== "") {
            var pnr = $("#pnr").val();
            var form = (document.getElementById("rvgform") as any);
            form.reset();
            localStorage.clear();
            $('#addrvggeb_modal').modal('show');
        }
        else {
            alert("Es muss eine Prozessregisternummer angegeben werden.");
        }
    }

    AddRVGEntry() {
        var rvgnummer = localStorage.getItem("rvgNummer");
        var rvgbezeichnung = $("#rvgbezeichnung").val();
        var rvgverfahren = localStorage.getItem("rvgVerfahren");
        var rvgstreitwert = localStorage.getItem("rvgStreitwert");
        var rvgbetrag = localStorage.getItem("rvgBetrag");
        var rvggebuehrensatz = localStorage.getItem("rvgGebuehrenSatz");


        if (rvgnummer !== null && rvgbezeichnung !== null && rvgbetrag !== null) {

            var keys = Object.keys(this.RVGList);
            var len = keys.length

            this.RVGList[len + 1] = { Art: 'G', Nummer: rvgnummer, Bezeichnung: rvgbezeichnung, GebuehrenSatz: rvggebuehrensatz, Streitwert: rvgstreitwert, Gebuehr: rvgbetrag }

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);

            var cell = new Array();
            for (var i = 0; i < 7; i++) {
                cell[i] = newRow.insertCell(i);
                cell[i].setAttribute("class", "text-left");
            }

            var text = new Array();
            text[0] = document.createTextNode(this.RVGList[len + 1].Art);
            text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
            text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
            text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
            text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
            text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
            text[6] = document.createTextNode("19,00");


            for (var i = 0; i < 7; i++) {
                cell[i].appendChild(text[i]);
            }

            $("#noentry").remove();

            $('#addrvggeb_modal').modal('hide');

        }
        else {
            alert("Fehler beim Speichern.");
        }

    }

    constructor() {
        $(document).ready(function () {
            $.ajaxSetup({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true
            });

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);

            var cell = new Array();
            cell[0] = newRow.insertCell(0);
            cell[0].setAttribute("class", "text-center text-muted");
            cell[0].setAttribute("id", "noentry");

            var text = new Array();
            text[0] = document.createTextNode("Keine Einträge vorhanden.");

            cell[0].appendChild(text[0]);
            cell[0].setAttribute("colspan", "7");

            $("#rvgstreitwert").keyup(function () {
                var streitwert = $("#rvgstreitwert").val() as string;
                if (isValidRVG()) {
                    localStorage.setItem("rvgStreitwert", streitwert);
                    calculateGebuehr();
                    updateDisplay();
                }

            })

            $("#rvgnummer").keyup(async function () {
                if (($(this).val() as string).length >= 2) {

                    var pnr = $("#rvgnummer").val();
                    pnr = pnr + " BY NUMBER";


                    let searchObject = {
                        "Query": pnr,
                        "Version": "2013"
                    }

                    localStorage.setItem("rvgStreitwert", $("#rvgstreitwert").val() as string);


                    let response = await RNSAPI.rvgSearch(searchObject);
                    var rvgData = response.Payload.RVGGeb[0];

                    if (typeof rvgData !== 'undefined') {
                        localStorage.setItem("rvgNummer", rvgData.ParagraphNummer.trim());
                        localStorage.setItem("rvgBezeichnung", rvgData.ParagraphBezeichnung.trim());
                        localStorage.setItem("rvgVerfahren", rvgData.Verfahren.trim());
                        localStorage.setItem("rvgGebuehrenSatz", rvgData.GebuehrenSatz.trim());
                        localStorage.setItem("rvgStreitwert", ($("#rvgstreitwert").val() as string).trim());
                        calculateGebuehr();

                    }
                    else {
                        localStorage.clear();
                        updateDisplay();
                    }
                    updateDisplay();
                }
            })
        });

        async function calculateGebuehr() {
            var streitwert = localStorage.getItem("rvgStreitwert");
            var nummer = localStorage.getItem("rvgNummer"); //paragraph
            var version = "2013";

            let calculateObject = {
                "Streitwert": streitwert,
                "Paragraph": nummer,
                "Version": version
            }

            if (isValidRVG()) {
                let response = await RNSAPI.rvgCalculate(calculateObject);

                var rvgData = response.Payload;

                localStorage.setItem("rvgBetrag", rvgData.Gebuehr.trim());

                updateDisplay();
            }
        }

        function updateDisplay() {
            $("#rvgverfahren").val(localStorage.getItem("rvgVerfahren"));
            if (localStorage.getItem("rvgStreitwert") === "" || localStorage.getItem("rvgStreitwert") === null) {
                $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung"));
            } else {
                $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung") + " aus " + localStorage.getItem("rvgStreitwert") + " EUR");
            }
            $("#rvggebuehrensatz").val(localStorage.getItem("rvgGebuehrenSatz"));
            $("#rvgbetrag").val(localStorage.getItem("rvgBetrag"));
        }


        function isValidRVG() {
            var isValid = false;

            if (localStorage.getItem("rvgNummer") !== null) {
                isValid = true;
            }

            return isValid;
        }

    }
}

let html = fs.readFileSync(__dirname + '/calculator.html', 'utf8');

ko.components.register("calculator-view", {
    viewModel: CalculatorViewModel,
    template: html
});
